import React, { useEffect, useState, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  List,
  Wrapper,
  SubTitle
} from './styled';
import {
  OptionChannel,
  ChannelsPublicationShimmer,
  TypePublicationModel,
  fetchPrintConsume,
  clearPrintSummaryId,
  FormActions,
  setPrintData,
  setTypePublicationSelected,
  fetchTypePublicationPackage,
  setExtracharge
} from '@app/src/views/StepTwo/channelPublication';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import { CATEGORIES, CATEGORY, CATEGORY_ID } from '@app/src/config/categories';
import { Title } from '@app/src/common/Title';
import { cleanAllDateSelected } from '@app/src/common/datePicker/state/calendar/actions';
import { configCalendarId, newspaperIdGroup } from './constants';
import { OptionChannelSummary } from '@app/src/views/StepTwo/channelPublication/components/OptionChannelSummary';
import { clearPriceTotal } from '@app/src/views/StepOne/form';
import { fetchMyPackageAvailable, setMyPackageAvailableAll } from '@app/src/common/CounterAvailable';

const isClient = isClientEnv();

export const ChannelsPublicationPackage: React.FC = () => {

  const history = useHistory();
  const dispatch = useDispatch();
  const { packageId } = useParams();

  const [isNextStep, setIsNextStep] = useState(false);
  const [publicationTitle, setPublicationTitle] = useState([]);
  const [isShowChannels, setIsShowChannels] = useState(true);
  const [currentNewspaper, setCurrentNewspaper] = useState(null);
  const [extraSelected, setExtraSelected] = useState(null);
  const printStorage = isClient && JSON.parse(sessionStorage.getItem('print'));

  const publications = useSelector(state => state.typePublication.data);
  const isFetching = useSelector(state => state.typePublication.isFetching);
  const error = useSelector(state => state.typePublication.error);
  const printData = useSelector(state => state.print);
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const summaryId = useSelector(state => state.print.summaryId);
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const extracharge = useSelector(state => state.extracharge.data);
  const photoVignette = useSelector(state => state.photoVignette.data);
  const printIsLoading = useSelector(state => state.print.isFetching);
  const priceTotal = useSelector(state => state.priceTotal);
  const currentChannel: TypePublicationModel = useSelector(state => state.typePublication.selected);
  const currentCalendar = useSelector(state => state.calendar);
  const availableData = useSelector(state => state.myPackageAvailable.data);
  const counter = useSelector(state => state.myPackageAvailable.counter);
  const categoryId = useSelector(state => state.print.general.category);
  const operationId = useSelector(state => state.print.general.operation);
  const propertyId = useSelector(state => state.print.general.property);
  const sectionId = useSelector(state => state.print.general.section);
  const typeVehicleId = useSelector(state => state.print.general.typeVehicle);
  const categoryConfig = CATEGORIES[CATEGORY[categoryId]];
  const userId = userStorage && userStorage.data && userStorage.data.id;

  useEffect(() => {
    if (categoryId) {
      if (printStorage && printStorage.general && categoryConfig && printStorage.general.category === categoryConfig.id && printStorage.general.operation) {
        if (printData && printData.general && Object.keys(printData.general).length === 0) {
          dispatch(setPrintData(printStorage));
        }
        dispatch(fetchMyPackageAvailable(userStorage && userStorage.data && userStorage.data.id, categoryConfig && categoryConfig.id, packageId));
        setExtraSelected(printStorage.extracharges);

        switch (categoryId) {
          case CATEGORY_ID.INMUEBLE:
            dispatch(fetchTypePublicationPackage(userId, categoryId, packageId, operationId, propertyId));
            break;
          case CATEGORY_ID.EMPLEO:
            dispatch(fetchTypePublicationPackage(userId, categoryId, packageId));
            break;
          case CATEGORY_ID.EDUCACION:
            dispatch(fetchTypePublicationPackage(userId, categoryId, packageId, operationId));
            break;
          case CATEGORY_ID.OPORTUNIDAD:
            dispatch(fetchTypePublicationPackage(userId, categoryId, packageId, operationId, sectionId));
            break;
          case CATEGORY_ID.VEHICULO:
            dispatch(fetchTypePublicationPackage(userId, categoryId, packageId, operationId, typeVehicleId));
            break;
          default:
            break;
        }
      } else {
        dispatch(cleanAllDateSelected());
        sessionStorage.setItem('print', JSON.stringify({ general: { category: categoryConfig.id } }));
        history.push(`${categoryConfig.paths.consumePackage.stepOne}/${packageId}`);
      }
    }
  }, [categoryId, userId, packageId, operationId, typeVehicleId]);

  useEffect(() => {
    if (publications && Object.keys(publications).length > 0 && extracharge && Object.keys(extracharge).length === 0) {
      const keys = Object.keys(publications);
      keys.map((key) => {
        dispatch(setExtracharge(Number(key), publications[key] && publications[key].extracharge));
      })
    }
  }, [publications, extracharge]);

  useEffect(() => {
    if (printData && printData.general && Object.keys(printData.general).length === 0) {
      dispatch(setPrintData(printStorage));
    }
  }, [printData]);

  useEffect(() => {
    if (availableData && availableData.newspapers && availableData.newspapers.length > 0 && counter && Object.keys(counter).length === 0) {
      let availables = { both: {} };
      availableData.newspapers.map(item => {
        availables[item.newspaper_id] = {
          print: item.quantity
        };
        item.extracharges && item.extracharges.map(extra => {
          availables[item.newspaper_id] = {
            ...availables[item.newspaper_id],
            extra: {
              ...availables[item.newspaper_id]['extra'],
              [extra.extracharge_id]: extra.quantity
            }
          };
        })
      });
      availableData && availableData.both && availableData.both.length > 0 && availableData.both.map(x => {
        availables['both'][x.extracharge_id] = x.quantity;
      });
      dispatch(setMyPackageAvailableAll(availables));
    }
  }, [availableData, counter]);

  useEffect(() => {
    if (extracharge && Object.keys(extracharge).length > 0) {
      setExtraSelected(extracharge);
    }
  }, [extracharge]);

  useEffect(() => {
    if (print && !isNotAnyPrint(printsByChannel) && isClient) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    }
  }, [printsByChannel]);

  const handleBeforeUnload = (e) => {
    const newPrint = { ...printData };
    newPrint['printsByChannel'] = {};
    newPrint['summaryId'] = '';
    newPrint['token'] = '';
    newPrint['extracharges'] = {};
    newPrint['priceTotal'] = {};
    newPrint['photoVignette'] = {};
    newPrint['channelSelected'] = {};
    newPrint['calendar'] = {};
    isClient && sessionStorage.setItem('print', JSON.stringify(newPrint));
    e.returnValue = '¿Desea descartar cambios?';
  };

  const handleClickNext = useCallback(async () => {
    if (isShowChannels) {
      updateDatalayer();
      const updated = getUpdateData();
      const userId = userStorage && userStorage.data && userStorage.data.id;
      dispatch(fetchPrintConsume(userId, printData.general.category, packageId, updated));
      setIsNextStep(true);
      isClient && sessionStorage.setItem('print', JSON.stringify(updated));
    } else {
      if (!isNotAnyPrint(printsByChannel)) {
        setIsShowChannels(true);
      }
    }
  }, [publicationTitle, printsByChannel, publications, isShowChannels]);

  const getUpdateData = () => {
    const updated = { ...printData };
    updated['extracharges'] = { ...extracharge };
    updated['priceTotal'] = { ...priceTotal };
    updated['photoVignette'] = { ...photoVignette };
    updated['channelSelected'] = { ...currentChannel };
    updated['calendar'] = { ...currentCalendar };
    return updated;
  };

  const updateDatalayer = () => {
    const selecteds = publicationTitle.join(', ');
    pushDatalayer(categoryConfig.name, selecteds);
    Object.keys(printsByChannel).forEach(key => {
      const channel = publications[key];
      pushDatalayerPayment(categoryConfig.name, key, channel);
    });
  };

  useEffect(() => {
    if (summaryId && isNextStep) {
      history.push(`${categoryConfig.paths.consumePackage.stepSummary}/${packageId}/${summaryId}`);
      dispatch(clearPrintSummaryId());
    }
  }, [summaryId, isNextStep, categoryConfig]);

  const isNotAnyPrint = (printsByChannel) => {
    let isNotPrint = true;
    let channelsId = printsByChannel && Object.keys(printsByChannel);
    if (channelsId && channelsId.length > 0) {
      channelsId.forEach((key) => {
        isNotPrint = isNotPrint && (printsByChannel && printsByChannel[key] && printsByChannel[key].length === 0)
      })
    }
    return isNotPrint;
  }

  const handleClickItem = (idNewspaper) => {
    setIsShowChannels(false);
    setCurrentNewspaper(idNewspaper);
  };

  const handleClickOptionDay = (publicationData, publicationDay, idChannel) => {
    dispatch(setTypePublicationSelected(publications[idChannel]));
    const currentTitle = `Clasificados ${publicationData} ${publicationDay}`;
    let isRepeat = false;
    for (let i = 0; i < publicationTitle.length; i++) {
      if (publicationTitle[i] === currentTitle) {
        isRepeat = true;
        break;
      }
    }
    if (publicationTitle.length === 0 || !isRepeat) {
      setPublicationTitle([...publicationTitle, currentTitle]);
    }
    history.push(`${categoryConfig.paths.consumePackage.stepCalendar}/${packageId}`);
  };

  const pushDatalayer = (categoryName: string, publicationName: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': `Paso 2.a - ${categoryName}`,
        'eventLabel': publicationName,
        'eventValue': 1
      })
    }
  };

  const pushDatalayerPayment = (categoryName: string, idPublication: string, channel) => {
    const printsTotal = idPublication && printsByChannel && printsByChannel[idPublication].length;
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': `Paso 2 - ${categoryName}`,
        'eventLabel': `Clasificados ${channel && channel.name} ${channel && channel.publicationDay}|${printsTotal}|S/ ${channel && channel.price * printsTotal}`,
        'eventValue': 1
      })
    }
  };

  const handleClickBack = (e) => {
    e.preventDefault();
    if (!isNotAnyPrint(printsByChannel)) {
      const isDiscard = confirm('¿Desea descartar cambios?');
      if (isDiscard) {
        dispatch(cleanAllDateSelected());
        dispatch(clearPriceTotal());
        delete printData.printsByChannel;
        isClient && sessionStorage.setItem('print', JSON.stringify(printData));
        history.push(`${categoryConfig.paths.consumePackage.stepOne}/${packageId}`);
      }
    } else {
      isClient && sessionStorage.setItem('print', JSON.stringify(printData));
      history.push(`${categoryConfig.paths.consumePackage.stepOne}/${packageId}`);
    }
  };

  const filterByChannelUnique = (publications) => {
    const currentData = Object.values(publications);
    if (currentData && currentData.length > 0) {
      const arrayUniqueByKey = [...new Map(currentData.map(item =>
        [item['newspaperId'], item])).values()]
      return arrayUniqueByKey;
    }
  };

  const filterByChannel = (publications) => {
    const channelData = Object.values(publications);
    return channelData.filter(item => item['newspaperId'] === currentNewspaper);
  };

  const getPrintsByNewspaperId = (printsByChannel, id) => {
    const obj = { 1: [], 2: [], 3: [] }
    Object.keys(printsByChannel).map(key => {
      newspaperIdGroup.map(id => {
        if (configCalendarId[key] && configCalendarId[key].groupId === id) {
          obj[id] = [
            ...obj[id],
            ...printsByChannel[key]
          ];
        }
      })
    });
    return obj[id];
  };

  const getExtraByNewspaperId = (extracharge, id) => {
    const obj = { 1: [], 2: [], 3: [] }
    Object.keys(extracharge).map(key => {
      newspaperIdGroup.map(id => {
        if (extracharge && configCalendarId[key] && configCalendarId[key].groupId === id && extracharge[key].data) {
          obj[id] = [
            ...obj[id],
            ...extracharge[key].data
          ];
        }
      })
    });
    return obj[id].filter(item => (item.checked === true));
  };

  return (
    <Wrapper>
      <Title>¿Dónde quieres publicar?</Title>
      <SubTitle>impresos</SubTitle>
      <List>
        {
          (isFetching || error) ?
            <ChannelsPublicationShimmer />
            :
            isShowChannels && publications && Object.keys(publications).length > 0 && filterByChannelUnique(publications) &&
            filterByChannelUnique(publications).map((channel: TypePublicationModel, key) => {
              return (
                <React.Fragment key={key}>
                  <OptionChannelSummary
                    key={key}
                    idNewspaper={channel.newspaperId}
                    title={channel.name}
                    priceIgv={channel.priceIgv}
                    details={printsByChannel && getPrintsByNewspaperId(printsByChannel, channel.newspaperId)}
                    handleClickItem={() => handleClickItem(channel.newspaperId)}
                    extrachargeSelected={extraSelected && getExtraByNewspaperId(extraSelected, channel.newspaperId)}
                    available={(counter && counter[channel.newspaperId] && counter[channel.newspaperId].print)}
                  />
                </React.Fragment>
              )
            })
        }
        {
          !isShowChannels && publications && Object.keys(publications).length > 0 && filterByChannel(publications) &&
          filterByChannel(publications).map((channel: TypePublicationModel, key) => {
            return (
              <React.Fragment key={key}>
                <OptionChannel
                  idNewspaper={channel.newspaperId}
                  idChannel={channel.id}
                  title={channel.name}
                  day={channel.publicationDay}
                  priceIgv={channel.priceIgv}
                  details={printsByChannel && printsByChannel[channel.id]}
                  printData={channel}
                  handleClickItem={() => handleClickOptionDay(channel.name, channel.publicationDay, channel.id)}
                  extra={extracharge}
                  available={(counter && counter[channel.newspaperId] && counter[channel.newspaperId].print)}
                />
              </React.Fragment>
            )
          })
        }
      </List>
      <FormActions
        textButtonBack={'Datos del aviso'}
        handleButtonBack={handleClickBack}
        handleButtonNext={handleClickNext}
        disabledButtonNext={isNotAnyPrint(printsByChannel) || printIsLoading} />
      <ModalErrorFeature />
    </Wrapper>
  );
};
